import { createReducer } from 'redux-starter-kit';
import {
  fetchSsoAppStatus,
  fetchSsoAppStatusFailure,
  fetchSsoAppStatusSuccess,
  loginViaSsoApp,
  loginViaSsoAppStatusFailure,
  loginViaSsoAppStatusSuccess
} from '../actions/sso-app';

export default createReducer(
  {
    isLoading: true,
    isTheSameAccount: false,
    loginIViaSsoInProgress: false,
    loginViaSsoError: null
  },
  {
    [fetchSsoAppStatus]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchSsoAppStatusSuccess]: (state, { payload }) => ({
      ...state,
      data: payload,
      error: null,
      isLoading: false
    }),
    [fetchSsoAppStatusFailure]: (state, { payload }) => ({
      ...state,
      error: payload,
      data: null,
      isLoading: false
    }),

    ///
    [loginViaSsoApp]: state => ({
      ...state,
      loginIViaSsoInProgress: true,
      loginViaSsoError: null
    }),
    [loginViaSsoAppStatusSuccess]: state => ({
      ...state,
      loginIViaSsoInProgress: false,
      loginViaSsoError: null
    }),
    [loginViaSsoAppStatusFailure]: (state, { payload }) => ({
      ...state,
      loginIViaSsoInProgress: false,
      loginViaSsoError: payload
    })
  }
);
